import React, { useState, useEffect, useRef } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import * as Yup from "yup";
import { useFormik } from "formik";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useDispatch, useSelector } from "react-redux";
import { getAdditionals, getCommodity, getContainersize, getContainertype, getCurrency, getDestinationCity, getDestinationCountry, getDestinationState, getIncoterms, getOriginCity, getOriginCountry, getOriginState, PackageApi, WeightUnitApi } from "../../Redux/action/MasterAction";
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";
import { FocusError } from "focus-formik-error";
import { adminMainUrl } from "../../Config";
import AsyncSelect from 'react-select/async';


const QuoteFormTransportation = ({ showProduction }) => {
  const token = Cookies.get('token');
  let user_id = Cookies.get('flexichain_user_id');
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    air: "0",
    road: "0",
    rail: "0",

  });

  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [showLoadSelectionBtn, setShowLoadSelectionBtn] = useState(false);
  const [quoteFormHeading, setQuoteFormHeading] = useState(false);
  const [quoteFormHeadingIcon, setQuoteFormHeadingIcon] = useState("");
  const [showLocationForm, setShowLocationForm] = useState(false);
  const [originCountryOptions, setOriginCountryOptions] = useState([]);
  const [originStateOptions, setOriginStateOptions] = useState([]);
  const [originCityOptions, setOriginCityOptions] = useState([]);
  const [destinationCountryOptions, setDestinationCountryOptions] = useState([]);
  const [destinationStateOptions, setDestinationStateOptions] = useState([]);
  const [destinationCityOptions, setDestinationCityOptions] = useState([]);
  const [incotermsOptions, setIncotermsOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [commodityOptions, setCommodityOptions] = useState([]);
  const [containerSizeOptions, setContainerSizeOptions] = useState([]);
  const [containerTypeOptions, setContainerTypeOptions] = useState([]);
  const [showOriginAddressForm, setShowOriginAddressForm] = useState(false);
  const [showDestinationAddressForm, setShowDestinationAddressForm] = useState(false);
  const [showIncoterms, setShowIncoterms] = useState(false);
  const [showRowAppendForm, setShowRowAppendForm] = useState(true);
  const [showCourierForms, setShowCourierForms] = useState(false);
  const [packageType, setPackageType] = useState([]);
  const [showVolume, setShowVolume] = useState(false);
  const [weightUnit, setWeightUnit] = useState([]);
  const [additionalsArray, setAdditionalArray] = useState([]);

  // const [disabled,setDisabled] = useState(false);
  //origin country state city
  const navigate = useNavigate()
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;

  useEffect(() => {
    if (!token) {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
    dispatch(getOriginCountry());
    dispatch(getDestinationCountry());
    dispatch(getCurrency());
    dispatch(getCommodity());
    dispatch(getIncoterms());
    dispatch(WeightUnitApi());
    dispatch(getContainertype());
    dispatch(getContainersize());
    dispatch(PackageApi());
    dispatch(getAdditionals());
  }, []);


  let findWeightUnitTypeData = useSelector((state) =>
    state?.MasterReducer ? state?.MasterReducer?.findWeightUnitTypeData : []
  );
  useEffect(() => {
    // console.log("findWeightUnitTypeData", findWeightUnitTypeData)
    if (findWeightUnitTypeData && findWeightUnitTypeData?.data) {
      let shipmentViaArr = [];
      findWeightUnitTypeData?.data?.map((val) => {
        if (val.status) {
          shipmentViaArr.push({ value: val.id, label: val.name });
        }
      });
      setWeightUnit(shipmentViaArr);
    }
  }, [findWeightUnitTypeData]);


  //master-> Additionals
  let { loadingAdditionals, additionalsDataError, additionalsData } = useSelector(state => state?.MasterReducer);
  useEffect(() => {
    if (additionalsData) {
      if (Array.isArray(additionalsData)) {
        let arr = additionalsData.map((val) => { if (val.status) { return { value: val.id, label: val.name } } });
        setAdditionalArray(arr);
      }
    }
  }, [additionalsData]);


  //master -> package type
  let findPackageTypeData = useSelector((state) =>
    state?.MasterReducer ? state?.MasterReducer?.findPackageTypeData : []
  );
  useEffect(() => {
    if (findPackageTypeData && findPackageTypeData?.data) {
      // console.log(findPackageTypeData)
      let packageTypeArr = [];
      findPackageTypeData?.data?.map((val) => {
        if (val.status) {
          packageTypeArr.push({ value: val.id, label: val.name });
        }
      });
      setPackageType(packageTypeArr);
    }
  }, [findPackageTypeData]);

  const delPriorityOptions = [
    { value: 'Normal', label: "Normal" },
    { value: 'Express', label: "Express" },
  ]

  const cargoTypeOptions = [
    { value: 'Goods', label: "Goods" },
    { value: 'Documents', label: "Documents" },
    { value: 'Furniture', label: "Furniture" },
    { value: 'Electronics', label: "Electronics" },
  ]

  const handlingTypeOptions = [
    { value: 'Fragile', label: "Fragile" },
    { value: 'Hazardous', label: "Hazardous" },
    { value: 'Oversized', label: "Oversized" },
    { value: 'High-value', label: "High-value" },
    { value: 'Temperature-sensitive,', label: "Temperature-sensitive," },
  ]

  const temperatureCondOptions = [
    { value: '-20C', label: "-20C" },
    { value: '8C', label: "8C" },
    { value: '9C', label: "9C" },
    { value: '10C', label: "10C" },
  ]

  // let additionalsArray = [
  //   { value: 1, label: "Origin charges" },
  //   { value: 2, label: "Freight charges" },
  //   { value: 3, label: "Destination charges" },
  //   { value: 4, label: "Refrigerated" },
  //   { value: 5, label: "Customs clearance origin" },
  //   { value: 6, label: "Hazardous cargo" },
  //   { value: 7, label: "Insurance" },
  //   { value: 8, label: "Overweight" },
  //   { value: 9, label: "Stackable" },
  // ];


  const handleOriginGetState = (id) => {
    try {
      if (id) {
        dispatch(getOriginState(id));
      }
    } catch (error) {
      console.log("Error in handleGetState function:", error.message);
    }
  };

  const handleOriginGetCity = (id) => {
    try {
      if (id) {
        dispatch(getOriginCity(id));
      }
    } catch (error) {
      console.log("Error in handleGetCity function:", error.message);
    }
  };


  //master-> origin country
  let originCountryData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.originCountryData : []);
  useEffect(() => {
    if (originCountryData) {
      let originCountryArr = [];
      originCountryData.map(val => { originCountryArr.push({ value: val.id, label: val.name }) });
      setOriginCountryOptions(originCountryArr);
    }
  }, [originCountryData]);

  //master-> origin state
  let originStateData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.originStateData : []);
  useEffect(() => {
    if (originStateData) {
      let originStateArr = [];
      originStateData.map(val => { originStateArr.push({ value: val.id, label: val.name }) });
      setOriginStateOptions(originStateArr);
    }
  }, [originStateData]);

  //master-> city
  let originCityData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.originCityData : []);
  useEffect(() => {
    if (originCityData) {
      let originCityArr = [];
      originCityData.map(val => { originCityArr.push({ value: val.id, label: val.name }) });
      setOriginCityOptions(originCityArr);
    }
  }, [originCityData]);


  //destination  state city
  const handleDestinationGetState = (id) => {
    try {
      if (id) {
        dispatch(getDestinationState(id));
      }
    } catch (error) {
      console.log("Error in handleGetState function:", error.message);
    }
  };

  const handleDestinationGetCity = (id) => {
    try {
      if (id) {
        dispatch(getDestinationCity(id));
      }
    } catch (error) {
      console.log("Error in handleGetCity function:", error.message);
    }
  };



  //master-> destination country
  let destinationCountryData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.destinationCountryData : []);
  useEffect(() => {
    if (destinationCountryData) {
      let destinationCountryArr = [];
      destinationCountryData.map(val => { destinationCountryArr.push({ value: val.id, label: val.name }) });
      setDestinationCountryOptions(destinationCountryArr);
    }
  }, [destinationCountryData]);

  //master-> destination state
  let destinationStateData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.destinationStateData : []);
  useEffect(() => {
    if (destinationStateData) {
      let destinationStateArr = [];
      destinationStateData.map(val => { destinationStateArr.push({ value: val.id, label: val.name }) });
      setDestinationStateOptions(destinationStateArr);
    }
  }, [destinationStateData]);

  //master-> city
  let destinationCityData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.destinationCityData : []);
  useEffect(() => {
    if (destinationCityData) {
      let destinationCityArr = [];
      destinationCityData.map(val => { destinationCityArr.push({ value: val.id, label: val.name }) });
      setDestinationCityOptions(destinationCityArr);
    }
  }, [destinationCityData]);


  //master -> incoterms
  let { loadingIncoterms, incotermsDataError, incotermsData } = useSelector(state => state?.MasterReducer);

  let currencyData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.currencyData : []);
  let commodityData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.commodityData : []);
  let containersizeData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.containersizeData : []);
  let containertypeData = useSelector(state => state?.MasterReducer ? state?.MasterReducer?.containertypeData : []);

  useEffect(() => {
    if (incotermsData) {
      let incotermsArr = [];
      incotermsData.map(val => { if (val.status) { incotermsArr.push({ value: val.id, label: val.name }) } });
      setIncotermsOptions(incotermsArr);
    }
  }, [loadingIncoterms, incotermsDataError, incotermsData]);

  useEffect(() => {
    if (currencyData) {
      let currencyArr = [];
      // currencyData.map(val => { currencyArr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }) });
      currencyData.forEach(val => {
        const label = `${val.currency} (${val.currency_symbol})`;
        // Check if the label already exists in currencyArr
        if (!currencyArr.some(item => item.label === label)) {
          currencyArr.push({ value: val.id, label });
        }
      });

      setCurrencyOptions(currencyArr);
      formik.setFieldValue("requested_currency_id", 101);
    }
  }, [currencyData]);

  useEffect(() => {
    if (commodityData) {
      let commodityArr = [];
      commodityData.map(val => { if (val.status) { commodityArr.push({ value: val.id, label: val.name }) } });
      setCommodityOptions(commodityArr);
    }
  }, [commodityData]);


  //container size
  useEffect(() => {
    if (containersizeData) {
      let containersizeArr = [];
      containersizeData.map(val => { if (val.status) { containersizeArr.push({ value: val.id, label: val.name }) } });
      setContainerSizeOptions(containersizeArr);
    }
  }, [containersizeData]);

  //container type
  useEffect(() => {
    if (containertypeData) {
      let containertypeArr = [];
      containertypeData.map(val => { if (val.status) { containertypeArr.push({ value: val.id, label: val.name }) } });
      setContainerTypeOptions(containertypeArr);
    }
  }, [containertypeData]);


  const [originAirPortLoading, setOriginAirportLoading] = useState(false);
  const fetchOriginAirport = async (inputValue) => {
    // Check if the input has at least 2 characters
    if (inputValue.length < 2) return [];
    try {
      setOriginAirportLoading(true);
      const response = await fetch(`${adminMainUrl}/api/airport/search?search_text=${inputValue}`);
      const data = await response.json();
      // console.log(data);
      await setOriginAirportLoading(false);
      if (data.data) {
        // console.log(data.data);
        return data.data.map((airport) => ({
          value: airport.id,
          label: `${airport.name} (${airport.code})`, // Format as you like
          city_id: airport.city_id,
          city_name: airport.city_name,
          state_id: airport.state_id,
          state_name: airport.state_name,
          country_id: airport.country_id,
          country_name: airport.country_name,
        }));
      } else {
        return []
      }

    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };

  const [destinationAirPortLoading, setDestinationAirportLoading] = useState(false);
  const fetchDestinationAirport = async (inputValue) => {
    // Check if the input has at least 2 characters
    if (inputValue.length < 2) return [];
    try {
      setDestinationAirportLoading(true);
      const response = await fetch(`${adminMainUrl}/api/airport/search?search_text=${inputValue}`);
      const data = await response.json();
      // console.log(data);
      await setDestinationAirportLoading(false);
      if (data.data) {
        return data.data.map((airport) => ({
          value: airport.id,
          label: `${airport.name} (${airport.code})`, // Format as you like
          city_id: airport.city_id,
          city_name: airport.city_name,
          state_id: airport.state_id,
          state_name: airport.state_name,
          country_id: airport.country_id,
          country_name: airport.country_name,
        }));
      } else {
        return []
      }

    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };

  const [originSeaPortLoading, setOriginSeaportLoading] = useState(false);
  const fetchOriginSeaport = async (inputValue) => {
    // Check if the input has at least 2 characters
    if (inputValue.length < 2) return [];
    try {
      setOriginSeaportLoading(true);
      const response = await fetch(`${adminMainUrl}/api/seaport/search?search_text=${inputValue}`);
      const data = await response.json();
      // console.log(data);
      await setOriginSeaportLoading(false);
      if (data.data) {
        return data.data.map((airport) => ({
          value: airport.id,
          label: `${airport.name} (${airport.code})`, // Format as you like
          city_id: airport.city_id,
          city_name: airport.city_name,
          state_id: airport.state_id,
          state_name: airport.state_name,
          country_id: airport.country_id,
          country_name: airport.country_name,
        }));
      } else {
        return []
      }

    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };

  const [destinationSeaPortLoading, setDestinationSeaportLoading] = useState(false);
  const fetchDestinationSeaport = async (inputValue) => {
    // Check if the input has at least 2 characters
    if (inputValue.length < 2) return [];
    try {
      setDestinationSeaportLoading(true);
      const response = await fetch(`${adminMainUrl}/api/seaport/search?search_text=${inputValue}`);
      const data = await response.json();
      // console.log(data);
      await setDestinationSeaportLoading(false);
      if (data.data) {
        return data.data.map((airport) => ({
          value: airport.id,
          label: `${airport.name} (${airport.code})`, // Format as you like
          city_id: airport.city_id,
          city_name: airport.city_name,
          state_id: airport.state_id,
          state_name: airport.state_name,
          country_id: airport.country_id,
          country_name: airport.country_name,
        }));
      } else {
        return []
      }

    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };






  let originAddressValidation = {};
  let destinationAddressValidation = {};





  let validationRules = {};

  if (showVolume === true) {
    validationRules = {
      volume: Yup.number()
        .required('Please enter volume')
        .typeError('Volume must be a number')
        .min(1, 'Volume must be at least 1')
        .max(9999, 'Volume must be less than 9999'),
    };
  } else {
    validationRules = {
      length: Yup.number()
        .required('Please enter length')
        .typeError('length must be a number')
        .min(1, 'length must be at least 1')
        .max(9999, 'length must be less than 9999'),

      width: Yup.number()
        .required('Please enter width')
        .typeError('width must be a number')
        .min(1, 'width must be at least 1')
        .max(9999, 'width must be less than 9999'),

      height: Yup.number()
        .required('Please enter height')
        .typeError('height must be a number')
        .min(1, 'height must be at least 1')
        .max(9999, 'height must be less than 9999'),
    };
  }
  let FCLvalidation = {};
  let qtyValidation = {};
  if (showRowAppendForm === true) {
    FCLvalidation = {
      ...validationRules,
      package_type_id: Yup.string().required("Please select package type"),
      total_boxes: Yup.number().required("Please enter quantity"),
      max_weight: Yup.number().required("Please enter approx weight"),
      max_weight_unit: Yup.string().required("Please select approx weight unit"),
      gross_weight_unit: Yup.string().required("Please enter gross weight unit"),
      gross_weight: Yup.number().required("Please enter gross weight"),
      // ...validationRules
    }
  } else {
    qtyValidation = {
      fl_quantity: Yup.string().required("Please enter quantity."),
      fl_containersize_id: Yup.string().required("Please select container size."),
      fl_containertype_id: Yup.string().required("Please select container type."),
    }
  }
  let incotermValidation = {}
  if (showIncoterms === "true") {
    incotermValidation = {
      // incoterm_id: Yup.string().required("Please select incoterms.")
    }
  };

  let loadTypeValidation = {};


  let airValidation =
    Yup.object().shape({
      // handling_type: Yup.string().required("Please select handling type"),
      // special_instruction: Yup.string().required("Please enter special instruction"),
      // temperature_cond: Yup.string().required("Please select temperature condition"),
      // packaging_details: Yup.string().required("Please enter packaging details"),
      // insurance_value: Yup.string().when("insuranceRequested", {
      //   is: true, // Required only if checkbox is checked
      //   then: Yup.string().required("Insurance value is required"),
      //   otherwise: Yup.string(),
      // }),
      delivery_priority: Yup.string().required("Please select delivery type"),
      cargo_type: Yup.string().required("Please select cargo type"),
      cargo_description: Yup.string().required("Please select cargo description"),
      pickup_date:Yup.string().required("Please select pickup date"),
      delivery_date:Yup.string().required("Please select delivery date"),
      full_name: Yup.string().required("Please enter full name"),
      insuranceRequested: Yup.boolean(),
      insurance_value: Yup.string().when("insuranceRequested", {
        is: (val) => val == true, // Explicitly check for true
        then:()=> Yup.string().required("Insurance value is required."),
        otherwise:()=> Yup.string().notRequired(),
      }),
      email: Yup.string()
        .email("Please enter a valid email address.")
        .required("Please enter your email address."),
      phone: Yup.string()
        .matches(/^\d{10}$/, "Phone Number must contain exactly 10 digits")
        .required("Please enter your phone number"),
      // quotation_user_type: Yup.string().required("Please select User type."),
      ...incotermValidation,
      // cargo_ready_date: Yup.date().required("Please select date"),
      // requested_currency_id: Yup.string().required("Please select currency."),
      // commodity_id: Yup.string().required("Please select commodity."),

      //validation for addresss
      origin_port_id: Yup.string().when(['shipment_mode', 'origin_type'], {
        is: (shipment_mode, origin_type) => (shipment_mode === "air" || shipment_mode === "ocean") && (origin_type === "AIRPORT"),
        then: () => Yup.string().required('Please select origin.'),
        otherwise: () => Yup.string().notRequired(),
      }),

      origin_address: Yup.string().when(['shipment_mode', 'origin_type'], {
        is: (shipment_mode, origin_type) => (shipment_mode === "air"),
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please enter address.'),
      }),
      origin_country_id: Yup.string().when(['shipment_mode', 'origin_type'], {
        is: (shipment_mode, origin_type) => (shipment_mode === "air"),
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please select country.'),
      }),
      origin_state_id: Yup.string().when(['shipment_mode', 'origin_type'], {
        is: (shipment_mode, origin_type) => (shipment_mode === "air"),
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please select state.'),
      }),
      origin_city_id: Yup.string().when(['shipment_mode', 'origin_type'], {
        is: (shipment_mode, origin_type) => (shipment_mode === "air"),
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please select city.'),
      }),
      // origin_pincode: Yup.string().when(['shipment_mode', 'origin_type', 'origin_pincode_notavailable'], {
      //   is: (shipment_mode, origin_type, origin_pincode_notavailable) => (shipment_mode === "air" || shipment_mode === "ocean") && (origin_type === "AIRPORT") && origin_pincode_notavailable === false,
      //   then: () => Yup.string().notRequired(),
      //   otherwise: () => Yup.string().required('Please enter pincode.'),
      // }),
      destination_port_id: Yup.string().when(['shipment_mode', 'destination_type'], {
        is: (shipment_mode, destination_type) => (shipment_mode === "air" ) && destination_type === "AIRPORT",
        then: () => Yup.string().required('Please select destination.'),
        otherwise: () => Yup.string().notRequired(),
      }),
      destination_address: Yup.string().when(['shipment_mode', 'destination_type'], {
        is: (shipment_mode, destination_type) => (shipment_mode === "air" ) && destination_type === "AIRPORT",
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please enter address.'),
      }),
      destination_country_id: Yup.string().when(['shipment_mode', 'destination_type'], {
        is: (shipment_mode, destination_type) => (shipment_mode === "air" ) && destination_type === "AIRPORT",
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please select country.'),
      }),
      destination_state_id: Yup.string().when(['shipment_mode', 'destination_type'], {
        is: (shipment_mode, destination_type) => (shipment_mode === "air" ) && destination_type === "AIRPORT",
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please select state.'),
      }),
      destination_city_id: Yup.string().when(['shipment_mode', 'destination_type'], {
        is: (shipment_mode, destination_type) => (shipment_mode === "air" ) && destination_type === "AIRPORT",
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Please select city.'),
      }),
      // destination_pincode: Yup.string().when(['shipment_mode', 'destination_type', 'destination_pincode_notavailable'], {
      //   is: (shipment_mode, destination_type, destination_pincode_notavailable) => (shipment_mode === "air" || shipment_mode === "ocean") && destination_type === "AIRPORT" && destination_pincode_notavailable === false,
      //   then: () => Yup.string().notRequired(),
      //   otherwise: () => Yup.string().required('Please select pincode.'),
      // }),


      load_type: showLoadSelectionBtn ? Yup.string().required("Please select load type.") : Yup.string(),
      ...qtyValidation,
      ...loadTypeValidation,
      // ...FCLvalidation,
      // fl_weight: Yup.string().required("Please enter weight."),
      // fl_weight_unit_id: Yup.string().required("Please select weight unit."),
      //
      package_info_arr: Yup.array().of(
        Yup.object({
          // fl_quantity: Yup.string().required("Please enter quantity."),
          ...FCLvalidation
          // fl_containersize_id: Yup.string().required("Please select container size."),
          // fl_containertype_id: Yup.string().required("Please select container type."),
        })
      ).notRequired()
    })

  const validationSchema = Yup.object().shape({
    ...airValidation.fields, // Spreading the fields from airValidation
  });



  //formik
  const formik = useFormik({
    initialValues: {
      handling_type: "",
      special_instruction: "",
      temperature_cond: "",
      packaging_details: "",
      insuranceRequested:false,
      insurace_value: "",
      cargo_type: "",
      cargo_description: "",
      delivery_priority: "",
      pickup_date:"",
      delivery_date:"",
      request_via: "panel",
      shipment_mode: "",
      origin_type: "AIRPORT",
      destination_type: "AIRPORT",
      load_type: "",
      origin_port_id: "",
      origin_port_country_id: "",
      origin_port_state_id: "",
      origin_port_city_id: "",
      origin_port_country_name: "",
      origin_port_state_name: "",
      origin_port_city_name: "",
      origin_address: "",
      origin_country_id: "",
      origin_state_id: "",
      origin_city_id: "",
      origin_pincode: "",
      origin_pincode_notavailable: "",
      destination_port_id: "",
      destination_port_country_id: "",
      destination_port_state_id: "",
      destination_port_city_id: "",
      destination_port_country_name: "",
      destination_port_state_name: "",
      destination_port_city_name: "",
      destination_address: "",
      destination_country_id: "",
      destination_state_id: "",
      destination_city_id: "",
      destination_pincode: "",
      destination_pincode_notavailable: "",
      full_name: "",
      email: "",
      phone: "",
      quotation_user_type: "",
      incoterm_id: "",
      cargo_ready_date: "",
      requested_currency_id: "",
      commodity_id: "",
      service_type: "",
      fl_quantity: "",
      fl_containersize_id: "",
      fl_containertype_id: "",
      fl_weight: "",
      fl_weight_unit_id: "",
      package_volume_type: "DIMENSIONS",
      pl_package_info: [
        {
          package_type_id: "",
          length: "",
          width: "",
          height: "",
          dimensionunit: "Cm",
          volume: "",
          volumeunit: "Cbm",
          max_weight: "",
          max_weight_unit: "Ton",
          gross_weight: "",
          gross_weight_unit: "Ton",
          total_boxes: "",
        },
      ],
      package_info_arr: [
        {
          package_type_id: "",
          length: "",
          width: "",
          height: "",
          dimensionunit: "Cm",
          volume: "",
          volumeunit: "Cbm",
          max_weight: "",
          max_weight_unit: "Ton",
          gross_weight: "",
          gross_weight_unit: "Ton",
          total_boxes: "",
        },
      ],
      additionals: [],
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      // console.log(values);
      values.pl_package_info = values.package_info_arr

      setDisableSubmitBtn(true);
      try {
        let config = { headers: { 'auth-token': Cookies.get('token'), 'user_id': user_id } }
        axios.post(`${adminMainUrl}/api/transport-quotation/transport-create-new-quote`, values, config)
          .then(response => {
            if (response.status == 200) {
              setDisableSubmitBtn(false);
              toast.success(response?.data?.msg);
              setSelectedCard("");
              resetForm();
              navigate('/flexichain/transport-quote-list');
            } else {
              setDisableSubmitBtn(false);
              toast.error(response?.data?.msg)
            }
          })
          .catch(err => {
            console.log(err);
            setDisableSubmitBtn(false);
            let msg = "";
            if (err.response) {
              msg = err.response.data.msg;
            } else {
              msg = "Internal Server Error!"
            };
            toast.error(msg);
          })
      } catch (error) {
        setDisableSubmitBtn(false);
        console.log(error);
        toast.error("Internal Server Error!")
      }
    }
  });


  // useEffect(() => {
  //   if (formik.errors) { console.log("======>", formik.errors) }
  // }, [formik.errors])


  // const isLastRowFilled = () => {
  //   const lastRow =
  //     formik.values.package_info_arr[formik.values.package_info_arr?.length - 1];
  //   return Object.values(lastRow).every((value) => value !== "");
  // };
  const isLastRowFilled = () => {
    const lastRow = formik.values.package_info_arr[formik.values.package_info_arr?.length - 1];
    const allOtherFieldsFilled = Object.entries(lastRow)
      .filter(([key]) => !["volume", "length", "width", "height"].includes(key))
      .every(([_, value]) => value !== "");

    if (showVolume) {
      return allOtherFieldsFilled && lastRow.volume !== "";
    } else {
      return (
        allOtherFieldsFilled &&
        lastRow.length !== "" &&
        lastRow.width !== "" &&
        lastRow.height !== ""
      );
    }
  };

  const handleRemoveRow = (index) => {
    const updatedPackageInfo = formik.values.package_info_arr.filter(
      (_, i) => i !== index
    );
    formik.setFieldValue("package_info_arr", updatedPackageInfo);
  };

  const handleAddRow = () => {
    if (isLastRowFilled()) {
      formik.setFieldValue("package_info_arr", [
        ...formik.values.package_info_arr,
        {
          package_type_id: "",
          length: "",
          width: "",
          height: "",
          dimensionunit: "Cm",
          volume: "",
          volumeunit: "Cbm",
          max_weight: "",
          max_weight_unit: "Ton",
          gross_weight: "",
          gross_weight_unit: "Ton",
          total_boxes: "",
        },
      ]);
    } else {
      toast.error("Please fill in all fields before adding a new row.")
    }
  };


  const handleCardClick = (card) => {
    formik.setFieldValue("shipment_mode", card);
    setSelectedCard(selectedCard === card ? null : card);
  };



  const handleOriginType = (origin) => {
    formik.setFieldValue("origin_type", origin);
  }

  const handleDestinationType = (destination) => {
    formik.setFieldValue("destination_type", destination);
  }


  useEffect(() => {
    if (formik.values.shipment_mode) {
      setShowLocationForm(true);
      if (formik.values.shipment_mode == "air") { setQuoteFormHeading("Air"); setQuoteFormHeadingIcon("plane"); setShowLoadSelectionBtn(false); setShowRowAppendForm(true); setShowCourierForms(false); }
      if (formik.values.shipment_mode == "road") { setQuoteFormHeading("Road"); setQuoteFormHeadingIcon("Road"); setShowLoadSelectionBtn(false); setShowCourierForms(true); }
      if (formik.values.shipment_mode == "rail") { setQuoteFormHeading("Rail"); setQuoteFormHeadingIcon("rail"); setShowLoadSelectionBtn(false); setShowCourierForms(true); }
    } else {
      setShowLocationForm(false);
    }
  }, [formik.values.shipment_mode]);


  useEffect(() => {
    if (formik.values.origin_type) {
      if (formik.values.origin_type == "AIRPORT") { setShowOriginAddressForm(false) }
      if (formik.values.origin_type == "WAREHOUSE") { setShowOriginAddressForm(true) }
      if (formik.values.origin_type == "BUSINESS") { setShowOriginAddressForm(true) }
      if (formik.values.origin_type == "RESIDENTIAL") { setShowOriginAddressForm(true) }
    }
  }, [formik.values.origin_type])

  useEffect(() => {
    if (formik.values.destination_type) {
      if (formik.values.destination_type == "AIRPORT") { setShowDestinationAddressForm(false) }
      if (formik.values.destination_type == "WAREHOUSE") { setShowDestinationAddressForm(true) }
      if (formik.values.destination_type == "BUSINESS") { setShowDestinationAddressForm(true) }
      if (formik.values.destination_type == "RESIDENTIAL") { setShowDestinationAddressForm(true) }
    }
  }, [formik.values.destination_type]);

  useEffect(() => {
    if (formik.values.package_volume_type == "DIMENSIONS") {
      setShowVolume(false);
    } else if (formik.values.package_volume_type == "VOLUME") {
      setShowVolume(true);
    }
  }, [formik.values.package_volume_type])

  useEffect(() => {
    if (formik.values.load_type) {
      if (formik.values.load_type == "FULL") {
        setShowRowAppendForm(false)

      }
      else if (formik.values.load_type == "PARTIAL") {
        setShowRowAppendForm(true)

      }
      else {
        setShowRowAppendForm(true)
      }
    }
  }, [formik.values.load_type]);





  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      In most cases we need a postal or zip code to get correct door rates, so if you know it please enter it here. Otherwise check the box to continue.
    </Tooltip>
  );

  const handleSelectChangeAddress = (event, card) => {
    setSelectedOptions({ ...selectedOptions, [card]: event.target.value });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 29,
      minHeight: 29,
      display: 'flex',
      alignItems: 'center',
    }),
    placeholder: (base) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: "600",
      color: '#808080',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    option: (base) => ({
      ...base,
      fontSize: '12px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '12px',
      display: 'flex', // Ensure singleValue aligns center vertically
      alignItems: 'center',
    }),
  };


  // useEffect(()=>{
  //   console.log('errrrr',formik.errors)
  //   console.log('valeee',formik.values)
  // },[formik])


  return (
    <>
      <div className="page-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <FocusError formik={formik} />
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-8">
                      <h4 className="page-title">Transport Quote Request Form</h4>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <div className="container">
                  <div className="row">
                    <div className="col-md-3 d-flex align-items-center">
                      <div className="services-tab-head">
                        <h6>What Shipping method?</h6>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="p-3">
                        <div
                          className={`card service-card service-card-form ${selectedCard === "air" ? "active" : ""
                            }`}
                          onClick={() => handleCardClick("air")}
                        >
                          <div className="card-body card-body-form">
                            <div className="card-content card-content-form">
                              <div className="icon">
                                <svg
                                  width={20}
                                  height={20}
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_16_117)">
                                    <path
                                      d="M15 0C13.5244 0 12.5775 1.11 12.0525 2.15812C11.5331 3.2406 11.2591 4.4244 11.25 5.625V12.5456L7.5 14.4206V14.0625C7.5 13.8139 7.40123 13.5754 7.22541 13.3996C7.0496 13.2238 6.81114 13.125 6.5625 13.125H4.6875C4.43886 13.125 4.2004 13.2238 4.02459 13.3996C3.84877 13.5754 3.75 13.8139 3.75 14.0625V16.2956L1.55625 17.3925C1.08869 17.6259 0.695407 17.985 0.420522 18.4295C0.145636 18.8739 1.76532e-05 19.3862 0 19.9088L0 22.5C6.26437e-05 22.6361 0.0297519 22.7705 0.0870054 22.894C0.144259 23.0174 0.227704 23.127 0.331543 23.2149C0.435383 23.3029 0.557128 23.3672 0.68832 23.4033C0.819512 23.4395 0.957006 23.4467 1.09125 23.4244L4.14937 22.9144L4.73625 24.6712C4.79876 24.8575 4.91819 25.0193 5.07765 25.134C5.23712 25.2487 5.42858 25.3104 5.625 25.3104C5.82142 25.3104 6.01288 25.2487 6.17235 25.134C6.33181 25.0193 6.45124 24.8575 6.51375 24.6712L7.27312 22.395L11.4169 21.7031L12.12 25.9275L9.64875 28.3988C9.5173 28.5299 9.42774 28.6971 9.39143 28.8791C9.35512 29.0612 9.37368 29.25 9.44478 29.4215C9.51587 29.593 9.6363 29.7395 9.79078 29.8425C9.94526 29.9455 10.1268 30.0003 10.3125 30H19.6875C19.8732 30.0003 20.0547 29.9455 20.2092 29.8425C20.3637 29.7395 20.4841 29.593 20.5552 29.4215C20.6263 29.25 20.6449 29.0612 20.6086 28.8791C20.5723 28.6971 20.4827 28.5299 20.3512 28.3988L17.88 25.9275L18.5831 21.7031L22.7269 22.395L23.4862 24.6712C23.5488 24.8575 23.6682 25.0193 23.8277 25.134C23.9871 25.2487 24.1786 25.3104 24.375 25.3104C24.5714 25.3104 24.7629 25.2487 24.9223 25.134C25.0818 25.0193 25.2012 24.8575 25.2638 24.6712L25.8506 22.9144L28.9069 23.4244C29.0413 23.447 29.179 23.44 29.3104 23.404C29.4418 23.368 29.5638 23.3037 29.6679 23.2157C29.7719 23.1278 29.8555 23.0181 29.9129 22.8945C29.9703 22.7709 30 22.6363 30 22.5V19.9088C30 19.3862 29.8544 18.8739 29.5795 18.4295C29.3046 17.985 28.9113 17.6259 28.4438 17.3925L26.25 16.2956V14.0625C26.25 13.8139 26.1512 13.5754 25.9754 13.3996C25.7996 13.2238 25.5611 13.125 25.3125 13.125H23.4375C23.1889 13.125 22.9504 13.2238 22.7746 13.3996C22.5988 13.5754 22.5 13.8139 22.5 14.0625V14.4206L18.75 12.5456V5.625C18.75 4.56 18.4875 3.24188 17.9475 2.15812C17.4225 1.10813 16.4756 0 15 0ZM13.125 5.625C13.125 4.815 13.3313 3.78937 13.7288 2.99813C14.1412 2.17313 14.6006 1.875 15 1.875C15.3994 1.875 15.8588 2.17125 16.2713 2.99813C16.6669 3.7875 16.875 4.81687 16.875 5.625V13.125C16.875 13.299 16.9234 13.4695 17.0148 13.6175C17.1062 13.7655 17.237 13.8852 17.3925 13.9631L27.6075 19.0706C27.763 19.1486 27.8938 19.2682 27.9852 19.4162C28.0766 19.5643 28.125 19.7348 28.125 19.9088V21.3937L17.9662 19.7006C17.7214 19.6599 17.4704 19.718 17.2683 19.8621C17.0662 20.0062 16.9294 20.2246 16.8881 20.4694L15.9506 26.0944C15.9258 26.242 15.9367 26.3934 15.9823 26.536C16.028 26.6785 16.1071 26.8081 16.2131 26.9137L17.4244 28.125H12.5756L13.7887 26.9137C13.8945 26.8082 13.9734 26.679 14.0191 26.5368C14.0647 26.3946 14.0758 26.2436 14.0512 26.0963L13.1137 20.4713C13.0935 20.3497 13.0495 20.2333 12.9843 20.1288C12.919 20.0243 12.8338 19.9336 12.7335 19.862C12.6332 19.7905 12.5198 19.7394 12.3997 19.7117C12.2796 19.684 12.1553 19.6802 12.0338 19.7006L1.875 21.3937V19.9088C1.87501 19.7348 1.92341 19.5643 2.01481 19.4162C2.1062 19.2682 2.23697 19.1486 2.3925 19.0706L12.6075 13.9631C12.763 13.8852 12.8938 13.7655 12.9852 13.6175C13.0766 13.4695 13.125 13.299 13.125 13.125V5.625Z"
                                      fill="#6470c5"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_16_117">
                                      <rect width={30} height={30} fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <h5 className="card-title card-title-form mt-2">Air</h5>
                            </div>
                          </div>
                          {/* <div className="card-img-overlay p-0">
                            <img
                              src="/assets/img/air-freight.png"
                              alt="Air Freight Image"
                              className="img-fluid"
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="p-3">
                        <div
                          className={`card service-card service-card-form ${selectedCard === "road" ? "active" : ""
                            }`}
                          onClick={() => handleCardClick("road")}
                        >
                          <div className="card-body card-body-form">
                            <div className="card-content card-content-form">
                              <div className="icon">
                                <svg
                                  width={20}
                                  height={21}
                                  viewBox="0 0 30 31"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.4822 23.2691C2.62887 23.6425 2.91597 23.9417 3.28034 24.1007C3.64471 24.2597 4.05652 24.2656 4.42516 24.117C4.7938 23.9684 5.08908 23.6775 5.24604 23.3084C5.403 22.9393 5.40879 22.5221 5.26212 22.1486L3.58819 17.8787L13.5122 15.6529V22.8451C13.5122 23.2467 13.6697 23.6318 13.95 23.9158C14.2303 24.1997 14.6104 24.3592 15.0068 24.3592C15.4032 24.3592 15.7833 24.1997 16.0636 23.9158C16.3439 23.6318 16.5014 23.2467 16.5014 22.8451V15.6529L26.4254 17.8787L24.7515 22.1486C24.6787 22.3335 24.6426 22.5311 24.6452 22.7302C24.6479 22.9292 24.6893 23.1258 24.767 23.3086C24.8448 23.4914 24.9573 23.6569 25.0983 23.7957C25.2392 23.9344 25.4058 24.0436 25.5884 24.117C25.7645 24.1875 25.9521 24.2234 26.1414 24.223C26.4408 24.2233 26.7333 24.1325 26.9811 23.9624C27.2289 23.7923 27.4206 23.5508 27.5314 23.2691L29.848 17.3487C29.9275 17.144 29.962 16.9241 29.9491 16.7044C29.9362 16.4848 29.8762 16.2706 29.7732 16.0768C29.6734 15.8838 29.5335 15.7148 29.3633 15.5816C29.1931 15.4483 28.9964 15.3538 28.7868 15.3046L23.9743 14.2296V7.70357C23.9743 7.302 23.8168 6.91686 23.5365 6.63291C23.2562 6.34895 22.8761 6.18942 22.4797 6.18942H19.4905V1.64696C19.4905 1.24539 19.3331 0.860256 19.0528 0.576297C18.7725 0.292339 18.3923 0.132813 17.996 0.132812H12.0176C11.6212 0.132813 11.2411 0.292339 10.9608 0.576297C10.6805 0.860256 10.523 1.24539 10.523 1.64696V6.18942H7.53389C7.1375 6.18942 6.75735 6.34895 6.47706 6.63291C6.19677 6.91686 6.03931 7.302 6.03931 7.70357V14.2296L1.22676 15.2743C1.01716 15.3235 0.820523 15.418 0.650279 15.5513C0.480036 15.6846 0.340201 15.8535 0.240332 16.0466C0.137399 16.2403 0.0773913 16.4545 0.0644854 16.6741C0.0515796 16.8938 0.0860863 17.1137 0.165603 17.3184L2.4822 23.2691ZM13.5122 3.16112H16.5014V6.18942H13.5122V3.16112ZM9.02847 9.21773H20.9851V13.5482L15.3356 12.246H14.678L9.02847 13.5482V9.21773ZM28.0246 26.2974C27.5002 26.4602 26.9981 26.6891 26.53 26.9787C26.0539 27.2608 25.5123 27.4095 24.9607 27.4095C24.4091 27.4095 23.8675 27.2608 23.3914 26.9787C22.356 26.387 21.1874 26.0761 19.9987 26.0761C18.81 26.0761 17.6413 26.387 16.606 26.9787C16.1233 27.2575 15.5773 27.4042 15.0217 27.4042C14.4661 27.4042 13.9201 27.2575 13.4375 26.9787C12.4012 26.3898 11.233 26.0806 10.0448 26.0806C8.85661 26.0806 7.68836 26.3898 6.65208 26.9787C6.17596 27.2608 5.63433 27.4095 5.08277 27.4095C4.53122 27.4095 3.98959 27.2608 3.51346 26.9787C3.04541 26.6891 2.54328 26.4602 2.01888 26.2974C1.82002 26.2257 1.60843 26.1976 1.39805 26.2148C1.18768 26.232 0.983277 26.2941 0.798312 26.3971C0.613347 26.5001 0.452011 26.6416 0.324925 26.8123C0.197839 26.983 0.107884 27.1791 0.0609827 27.3876C-0.0505943 27.771 -0.00792838 28.1837 0.179671 28.5354C0.36727 28.8872 0.684575 29.1495 1.06235 29.2651C1.36331 29.3477 1.65043 29.4753 1.91426 29.6436C2.82104 30.1827 3.85209 30.4699 4.90342 30.4764C5.99536 30.4766 7.06791 30.1841 8.01215 29.6285C8.59799 29.3011 9.25615 29.1294 9.92522 29.1294C10.5943 29.1294 11.2524 29.3011 11.8383 29.6285C12.7758 30.1716 13.8371 30.4573 14.9171 30.4573C15.9971 30.4573 17.0584 30.1716 17.996 29.6285C18.5818 29.3011 19.24 29.1294 19.909 29.1294C20.5781 29.1294 21.2362 29.3011 21.8221 29.6285C22.7484 30.1886 23.8072 30.4844 24.886 30.4844C25.9648 30.4844 27.0235 30.1886 27.9499 29.6285C28.2137 29.4601 28.5008 29.3326 28.8018 29.25C29.0007 29.2092 29.1893 29.1278 29.3561 29.0108C29.523 28.8938 29.6646 28.7436 29.7722 28.5693C29.8799 28.3951 29.9514 28.2004 29.9824 27.9972C30.0135 27.7941 30.0033 27.5866 29.9526 27.3876C29.9051 27.1826 29.816 26.99 29.6908 26.822C29.5657 26.6539 29.4074 26.5141 29.226 26.4115C29.0446 26.3089 28.844 26.2458 28.6372 26.2262C28.4303 26.2065 28.2217 26.2307 28.0246 26.2974Z"
                                    fill="#6470c5"
                                  />
                                </svg>
                              </div>
                              <h5 className="card-title card-title-form  mt-2">
                                Road
                              </h5>
                            </div>
                          </div>
                          {/* <div className="card-img-overlay p-0">
                            <img
                              src="/assets/img/sea.png"
                              alt="Sea Freight Image"
                              className="img-fluid"
                            />
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="p-3">
                        <div
                          className={`card service-card service-card-form ${selectedCard === "rail" ? "active" : ""
                            }`}
                          onClick={() => handleCardClick("rail")}
                        >
                          <div className="card-body card-body-form">
                            <div className="card-content card-content-form">
                              <div className="icon">
                                <svg
                                  width={20}
                                  height={21}
                                  viewBox="0 0 30 31"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.4822 23.2691C2.62887 23.6425 2.91597 23.9417 3.28034 24.1007C3.64471 24.2597 4.05652 24.2656 4.42516 24.117C4.7938 23.9684 5.08908 23.6775 5.24604 23.3084C5.403 22.9393 5.40879 22.5221 5.26212 22.1486L3.58819 17.8787L13.5122 15.6529V22.8451C13.5122 23.2467 13.6697 23.6318 13.95 23.9158C14.2303 24.1997 14.6104 24.3592 15.0068 24.3592C15.4032 24.3592 15.7833 24.1997 16.0636 23.9158C16.3439 23.6318 16.5014 23.2467 16.5014 22.8451V15.6529L26.4254 17.8787L24.7515 22.1486C24.6787 22.3335 24.6426 22.5311 24.6452 22.7302C24.6479 22.9292 24.6893 23.1258 24.767 23.3086C24.8448 23.4914 24.9573 23.6569 25.0983 23.7957C25.2392 23.9344 25.4058 24.0436 25.5884 24.117C25.7645 24.1875 25.9521 24.2234 26.1414 24.223C26.4408 24.2233 26.7333 24.1325 26.9811 23.9624C27.2289 23.7923 27.4206 23.5508 27.5314 23.2691L29.848 17.3487C29.9275 17.144 29.962 16.9241 29.9491 16.7044C29.9362 16.4848 29.8762 16.2706 29.7732 16.0768C29.6734 15.8838 29.5335 15.7148 29.3633 15.5816C29.1931 15.4483 28.9964 15.3538 28.7868 15.3046L23.9743 14.2296V7.70357C23.9743 7.302 23.8168 6.91686 23.5365 6.63291C23.2562 6.34895 22.8761 6.18942 22.4797 6.18942H19.4905V1.64696C19.4905 1.24539 19.3331 0.860256 19.0528 0.576297C18.7725 0.292339 18.3923 0.132813 17.996 0.132812H12.0176C11.6212 0.132813 11.2411 0.292339 10.9608 0.576297C10.6805 0.860256 10.523 1.24539 10.523 1.64696V6.18942H7.53389C7.1375 6.18942 6.75735 6.34895 6.47706 6.63291C6.19677 6.91686 6.03931 7.302 6.03931 7.70357V14.2296L1.22676 15.2743C1.01716 15.3235 0.820523 15.418 0.650279 15.5513C0.480036 15.6846 0.340201 15.8535 0.240332 16.0466C0.137399 16.2403 0.0773913 16.4545 0.0644854 16.6741C0.0515796 16.8938 0.0860863 17.1137 0.165603 17.3184L2.4822 23.2691ZM13.5122 3.16112H16.5014V6.18942H13.5122V3.16112ZM9.02847 9.21773H20.9851V13.5482L15.3356 12.246H14.678L9.02847 13.5482V9.21773ZM28.0246 26.2974C27.5002 26.4602 26.9981 26.6891 26.53 26.9787C26.0539 27.2608 25.5123 27.4095 24.9607 27.4095C24.4091 27.4095 23.8675 27.2608 23.3914 26.9787C22.356 26.387 21.1874 26.0761 19.9987 26.0761C18.81 26.0761 17.6413 26.387 16.606 26.9787C16.1233 27.2575 15.5773 27.4042 15.0217 27.4042C14.4661 27.4042 13.9201 27.2575 13.4375 26.9787C12.4012 26.3898 11.233 26.0806 10.0448 26.0806C8.85661 26.0806 7.68836 26.3898 6.65208 26.9787C6.17596 27.2608 5.63433 27.4095 5.08277 27.4095C4.53122 27.4095 3.98959 27.2608 3.51346 26.9787C3.04541 26.6891 2.54328 26.4602 2.01888 26.2974C1.82002 26.2257 1.60843 26.1976 1.39805 26.2148C1.18768 26.232 0.983277 26.2941 0.798312 26.3971C0.613347 26.5001 0.452011 26.6416 0.324925 26.8123C0.197839 26.983 0.107884 27.1791 0.0609827 27.3876C-0.0505943 27.771 -0.00792838 28.1837 0.179671 28.5354C0.36727 28.8872 0.684575 29.1495 1.06235 29.2651C1.36331 29.3477 1.65043 29.4753 1.91426 29.6436C2.82104 30.1827 3.85209 30.4699 4.90342 30.4764C5.99536 30.4766 7.06791 30.1841 8.01215 29.6285C8.59799 29.3011 9.25615 29.1294 9.92522 29.1294C10.5943 29.1294 11.2524 29.3011 11.8383 29.6285C12.7758 30.1716 13.8371 30.4573 14.9171 30.4573C15.9971 30.4573 17.0584 30.1716 17.996 29.6285C18.5818 29.3011 19.24 29.1294 19.909 29.1294C20.5781 29.1294 21.2362 29.3011 21.8221 29.6285C22.7484 30.1886 23.8072 30.4844 24.886 30.4844C25.9648 30.4844 27.0235 30.1886 27.9499 29.6285C28.2137 29.4601 28.5008 29.3326 28.8018 29.25C29.0007 29.2092 29.1893 29.1278 29.3561 29.0108C29.523 28.8938 29.6646 28.7436 29.7722 28.5693C29.8799 28.3951 29.9514 28.2004 29.9824 27.9972C30.0135 27.7941 30.0033 27.5866 29.9526 27.3876C29.9051 27.1826 29.816 26.99 29.6908 26.822C29.5657 26.6539 29.4074 26.5141 29.226 26.4115C29.0446 26.3089 28.844 26.2458 28.6372 26.2262C28.4303 26.2065 28.2217 26.2307 28.0246 26.2974Z"
                                    fill="#6470c5"
                                  />
                                </svg>
                              </div>
                              <h5 className="card-title card-title-form  mt-2">
                                Rail
                              </h5>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="card-body">

                {showLocationForm && (
                  <>
                    {/* <div className="d-flex mt-2 mb-3 form-heading">
                      <i className={`fa-solid fa-${quoteFormHeadingIcon}`}></i>
                      <h4>{quoteFormHeading} Quotation Form</h4>
                    </div> */}



                    <div className="row location-area">
                      <div className="col-md-5">
                        <div className="location-select">
                          <label className="form-label form-label-location">
                            Where are you shipping from ?
                          </label>
                          {
                            showCourierForms ?

                              <div className="row">

                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    Postal/Zip Code{" "}
                                    <span className="text-danger"></span>
                                  </label>
                                  <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    name="origin_pincode"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.origin_pincode}
                                    maxLength={10}
                                    placeholder={formik.values.origin_pincode_notavailable ? "Not available" : "Enter Postal/Zip code"}
                                    disabled={formik.values.origin_pincode_notavailable}
                                  />
                                  {formik?.touched.origin_pincode_notavailable &&
                                    formik?.errors.origin_pincode_notavailable ? (
                                    <div className="error">
                                      {formik?.errors.origin_pincode_notavailable}
                                    </div>
                                  ) : null}

                                </div>

                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    Country <span className="text-danger"></span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    options={originCountryOptions}
                                    name="origin_country_id"
                                    value={originCountryOptions.find(option => option.value === formik.values.origin_country_id)}
                                    onChange={option => {
                                      formik.setFieldValue('origin_country_id', option.value);
                                      handleOriginGetState(option.value);
                                      formik.setFieldValue('state_id', '');
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  {formik?.touched.origin_country_id &&
                                    formik?.errors.origin_country_id ? (
                                    <div className="error">
                                      {formik?.errors.origin_country_id}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    State <span className="text-danger"></span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    options={originStateOptions}
                                    name="origin_state_id"
                                    value={originStateOptions.find(option => option.value === formik.values.origin_state_id)}
                                    onChange={option => {
                                      formik.setFieldValue('origin_state_id', option.value);
                                      formik.setFieldValue('origin_door_state_name', option.label);
                                      handleOriginGetCity(option.value);
                                      formik.setFieldValue('city_id', '');
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  {formik?.touched.origin_state_id &&
                                    formik?.errors.origin_state_id ? (
                                    <div className="error">
                                      {formik?.errors.origin_state_id}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    City <span className="text-danger"></span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    options={originCityOptions}
                                    name="origin_city_id"
                                    value={originCityOptions.find(option => option.value === formik.values.origin_city_id)}
                                    onChange={option => {
                                      formik.setFieldValue('origin_city_id', option.value);
                                      formik.setFieldValue('origin_door_city_name', option.label);
                                      formik.setFieldValue('city_id', '');
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  {formik?.touched.origin_city_id &&
                                    formik?.errors.origin_city_id ? (
                                    <div className="error">
                                      {formik?.errors.origin_city_id}
                                    </div>
                                  ) : null}                                </div>

                                <div className="col-md-12">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    Address <span className="text-danger"></span>
                                  </label>
                                  <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    placeholder="Enter address"
                                    name="origin_address"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.origin_address}
                                  />
                                  {formik?.touched.origin_address &&
                                    formik?.errors.origin_address ? (
                                    <div className="error">
                                      {formik?.errors.origin_address}
                                    </div>
                                  ) : null}
                                </div>

                              </div>
                              :
                              <>
                                <div className="row p-2">
                                  {formik.values.shipment_mode == "air" ?
                                    <div className="col-md-3 icons-airport">
                                      <div className={`icons-airport-form ${formik.values.origin_type == "AIRPORT" ? "active" : ""}`} onClick={() => { handleOriginType("AIRPORT") }}>
                                        <i className="fa-solid fa-plane"></i>
                                        <p>Airport</p>
                                      </div>
                                    </div> :
                                   
                                      null
                                  }
                                  <div className="col-md-3 icons-airport">
                                    <div className={`icons-airport-form ${formik.values.origin_type == "WAREHOUSE" ? "active" : ""}`} onClick={() => { handleOriginType("WAREHOUSE") }}>
                                      <i className="fa-solid fa-warehouse"></i>
                                      <p>Warehouse</p>
                                    </div>
                                  </div>
                                  <div className="col-md-3 icons-airport">
                                    <div className={`icons-airport-form ${formik.values.origin_type == "BUSINESS" ? "active" : ""}`} onClick={() => { handleOriginType("BUSINESS") }}>
                                      <i className="fa-solid fa-building"></i>
                                      <p>Business</p>
                                    </div>
                                  </div>
                                  <div className="col-md-3 icons-airport">
                                    <div className={`icons-airport-form ${formik.values.origin_type == "RESIDENTIAL" ? "active" : ""}`} onClick={() => { handleOriginType("RESIDENTIAL") }}>
                                      <i className="fa-solid fa-shop"></i>
                                      <p>Residential</p>
                                    </div>
                                  </div>
                                </div>
                                {!showOriginAddressForm ?
                                  <>
                                    <div className="input-group">
                                      <button
                                        className="btn search-btn-popup"
                                        type="button"
                                        id="button-addon1"
                                      >
                                        <i className={`fa-solid  ${formik.values.shipment_mode == "air" ? "fa-plane" : "fa-ship"}`}></i>
                                      </button>
                                      {/* <input
                                        type="text"
                                        className="form-control input-search"
                                        placeholder="Search location"
                                        aria-label="Example text with button addon"
                                        aria-describedby="button-addon1"
                                        name="origin_port_id"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.origin_port_id}
                                      /> */}

                                      <AsyncSelect
                                        className="async-select"
                                        cacheOptions
                                        loadOptions={formik.values.shipment_mode == "air" ? fetchOriginAirport : fetchOriginSeaport} // Called when typing to fetch options
                                        placeholder={`Type to search ${formik.values.shipment_mode == "air" ? "airports" : "seaports"}...`}
                                        isClearable
                                        isLoading={formik.values.shipment_mode == "air" ? originAirPortLoading : originSeaPortLoading}
                                        loadingMessage={() => `Fetching ${formik.values.shipment_mode == "air" ? "airports" : "ports"}...`} // Shows loading message
                                        name="origin_port_id"
                                        onChange={option => {
                                          formik.setFieldValue('origin_port_int_id', option ? option.value : null);
                                          formik.setFieldValue('origin_port_id', option ? option.label : null);
                                          formik.setFieldValue('origin_port_country_id', option ? option.country_id : null);
                                          formik.setFieldValue('origin_port_state_id', option ? option.state_id : null);
                                          formik.setFieldValue('origin_port_city_id', option ? option.city_id : null);
                                          formik.setFieldValue('origin_port_country_name', option ? option.country_name : null);
                                          formik.setFieldValue('origin_port_state_name', option ? option.state_name : null);
                                          formik.setFieldValue('origin_port_city_name', option ? option.city_name : null);
                                        }}
                                        onBlur={formik.handleBlur}
                                        styles={{
                                          dropdownIndicator: (provided) => ({
                                            ...provided,
                                            display: 'none',
                                          }),
                                          indicatorSeparator: () => ({
                                            display: 'none',
                                          }),
                                        }}
                                      />
                                    </div>
                                    {formik?.touched.origin_port_id && formik?.errors.origin_port_id ? (
                                      <div className="error"> {formik.errors.origin_port_id} </div>
                                    ) : null}
                                    {formik.values.origin_port_id &&
                                      <div className="row mt-3 p-2">
                                        {formik.values.origin_port_city_name && <>
                                          <div className="col-md-4 mt-3">City</div>
                                          <div className="col-md-8 mt-3 fw-bold">{formik.values.origin_port_city_name}</div>
                                        </>}
                                        {formik.values.origin_port_country_name && <>
                                          <div className="col-md-4 mt-3">Country</div>
                                          <div className="col-md-8 mt-3 fw-bold">{formik.values.origin_port_country_name}</div>
                                        </>
                                        }
                                      </div>}
                                  </> :
                                  <div className="row">
                                    <div className="col-md-12">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        Address <span className="text-danger"></span>
                                      </label>
                                      <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        placeholder="Enter address"
                                        name="origin_address"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.origin_address}
                                      />
                                      {formik?.touched.origin_address &&
                                        formik?.errors.origin_address ? (
                                        <div className="error">
                                          {formik?.errors.origin_address}
                                        </div>
                                      ) : null}
                                    </div>

                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        Country <span className="text-danger"></span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        styles={customStyles}
                                        options={originCountryOptions}
                                        name="origin_country_id"
                                        value={originCountryOptions.find(option => option.value === formik.values.origin_country_id)}
                                        onChange={option => {
                                          formik.setFieldValue('origin_country_id', option.value);
                                          handleOriginGetState(option.value);
                                          formik.setFieldValue('state_id', '');
                                        }}
                                        onBlur={formik.handleBlur}
                                      />
                                      {formik?.touched.origin_country_id &&
                                        formik?.errors.origin_country_id ? (
                                        <div className="error">
                                          {formik?.errors.origin_country_id}
                                        </div>
                                      ) : null}
                                    </div>
                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        State <span className="text-danger"></span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        styles={customStyles}
                                        options={originStateOptions}
                                        name="origin_state_id"
                                        value={originStateOptions.find(option => option.value === formik.values.origin_state_id)}
                                        onChange={option => {
                                          formik.setFieldValue('origin_state_id', option.value);
                                          formik.setFieldValue('origin_door_state_name', option.label);
                                          handleOriginGetCity(option.value);
                                          formik.setFieldValue('city_id', '');
                                        }}
                                        onBlur={formik.handleBlur}
                                      />
                                      {formik?.touched.origin_state_id &&
                                        formik?.errors.origin_state_id ? (
                                        <div className="error">
                                          {formik?.errors.origin_state_id}
                                        </div>
                                      ) : null}
                                    </div>
                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        City <span className="text-danger"></span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        styles={customStyles}
                                        options={originCityOptions}
                                        name="origin_city_id"
                                        value={originCityOptions.find(option => option.value === formik.values.origin_city_id)}
                                        onChange={option => {
                                          formik.setFieldValue('origin_city_id', option.value);
                                          formik.setFieldValue('origin_door_city_name', option.label);
                                          formik.setFieldValue('city_id', '');
                                        }}
                                        onBlur={formik.handleBlur}
                                      />
                                      {formik?.touched.origin_city_id &&
                                        formik?.errors.origin_city_id ? (
                                        <div className="error">
                                          {formik?.errors.origin_city_id}
                                        </div>
                                      ) : null}
                                    </div>

                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        Postal/Zip Code{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                      <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        name="origin_pincode"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.origin_pincode}
                                        maxLength={10}
                                        placeholder={formik.values.origin_pincode_notavailable ? "Not available" : "Enter Postal/Zip code"}
                                        disabled={formik.values.origin_pincode_notavailable}
                                      />
                                      {formik?.touched.origin_pincode && formik?.errors.origin_pincode ? (
                                        <div className="error">{formik?.errors.origin_pincode}</div>
                                      ) : null}
                                      <div>
                                        <input
                                          id="origin_pincode_notavailable"
                                          type="checkbox"
                                          className="me-1"
                                          checked={formik.values.origin_pincode_notavailable}
                                          onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            formik.setFieldValue("origin_pincode_notavailable", isChecked);
                                            if (isChecked) {
                                              formik.setFieldValue("origin_pincode", "");
                                              formik.setFieldError('origin_pincode', ''); // Clear the error
                                              formik.setFieldTouched('origin_pincode', false);
                                            }
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <label
                                          for="basicpill-firstname-input"
                                          className="form-label"
                                          htmlFor="origin_pincode_notavailable"
                                        >
                                          {" "}
                                          Not available
                                        </label>

                                        <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 250, hide: 400 }}
                                          overlay={renderTooltip}
                                        >
                                          <i className="fa-solid fa-circle-info ms-1"></i>
                                        </OverlayTrigger>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </>
                          }
                        </div>
                      </div>
                      <div className="col-md-2 location-icon">
                        <div className="location-icon-distance">
                          <img src="/assets/img/distance.png" alt="" />
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="location-select">
                          <label className="form-label form-label-location">
                            Where are you shipping to?
                          </label>
                          {
                            showCourierForms ?
                              <div className="row">
                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    Postal/Zip Code{" "}
                                    <span className="text-danger"></span>
                                  </label>
                                  <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    name="destination_pincode"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.destination_pincode}
                                    maxLength={10}
                                    placeholder={formik.values.destination_pincode_notavailable ? "Not available" : "Enter Postal/Zip code"}
                                    disabled={formik.values.destination_pincode_notavailable}
                                  />
                                  {formik?.touched.destination_pincode && formik?.errors.destination_pincode ? (
                                    <div className="error">
                                      {formik?.errors.destination_pincode}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    Country <span className="text-danger"></span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    options={destinationCountryOptions}
                                    name="destination_country_id"
                                    value={destinationCountryOptions.find(option => option.value === formik.values.destination_country_id)}
                                    onChange={option => {
                                      formik.setFieldValue('destination_country_id', option.value);
                                      formik.setFieldValue('destination_door_country_name', option.label);
                                      handleDestinationGetState(option.value);
                                      formik.setFieldValue('state_id', '');
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  {formik?.touched.destination_country_id && formik?.errors.destination_country_id ? (
                                    <div className="error">
                                      {formik?.errors.destination_country_id}
                                    </div>
                                  ) : null}
                                </div>
                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    State <span className="text-danger"></span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    options={destinationStateOptions}
                                    name="destination_state_id"
                                    value={destinationStateOptions.find(option => option.value === formik.values.destination_state_id)}
                                    onChange={option => {
                                      formik.setFieldValue('destination_state_id', option.value);
                                      formik.setFieldValue('destination_door_state_name', option.label);
                                      handleDestinationGetCity(option.value);
                                      formik.setFieldValue('city_id', '');
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  {formik?.touched.destination_state_id && formik?.errors.destination_state_id ? (
                                    <div className="error">
                                      {formik?.errors.destination_state_id}
                                    </div>
                                  ) : null}
                                </div>
                                <div className="col-md-6">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    City <span className="text-danger"></span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    styles={customStyles}
                                    options={destinationCityOptions}
                                    name="destination_city_id"
                                    value={destinationCityOptions.find(option => option.value === formik.values.destination_city_id)}
                                    onChange={option => {
                                      formik.setFieldValue('destination_city_id', option.value);
                                      formik.setFieldValue('destination_door_city_name', option.label);
                                      formik.setFieldValue('city_id', '');
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  {formik?.touched.destination_city_id && formik?.errors.destination_city_id ? (
                                    <div className="error">
                                      {formik?.errors.destination_city_id}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="col-md-12">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label"
                                  >
                                    Address <span className="text-danger"></span>
                                  </label>
                                  <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    placeholder="Enter address"
                                    name="destination_address"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.destination_address}
                                  />
                                </div>
                                {formik?.touched.destination_address && formik?.errors.destination_address ? (
                                  <div className="error">
                                    {formik?.errors.destination_address}
                                  </div>
                                ) : null}
                              </div>
                              :
                              <>
                                <div className="row p-2">
                                  {
                                    formik.values.shipment_mode == "air" ?
                                      <div className="col-md-3 icons-airport">
                                        <div className={`icons-airport-form ${formik.values.destination_type == "AIRPORT" ? "active" : ""}`} onClick={() => { handleDestinationType("AIRPORT") }}>
                                          <i className="fa-solid fa-plane"></i>
                                          <p>Airport</p>
                                        </div>
                                      </div>
                                     
                                        :
                                        null
                                  }


                                  <div className="col-md-3 icons-airport">
                                    <div className={`icons-airport-form ${formik.values.destination_type == "WAREHOUSE" ? "active" : ""}`} onClick={() => { handleDestinationType("WAREHOUSE") }}>
                                      <i className="fa-solid fa-warehouse"></i>
                                      <p>Warehouse</p>
                                    </div>
                                  </div>
                                  <div className="col-md-3 icons-airport">
                                    <div className={`icons-airport-form ${formik.values.destination_type == "BUSINESS" ? "active" : ""}`} onClick={() => { handleDestinationType("BUSINESS") }}>
                                      <i className="fa-solid fa-building"></i>
                                      <p>Business</p>
                                    </div>
                                  </div>
                                  <div className="col-md-3 icons-airport">
                                    <div className={`icons-airport-form ${formik.values.destination_type == "RESIDENTIAL" ? "active" : ""}`} onClick={() => { handleDestinationType("RESIDENTIAL") }}>
                                      <i className="fa-solid fa-shop"></i>
                                      <p>Residential</p>
                                    </div>
                                  </div>
                                </div>
                                {!showDestinationAddressForm ?
                                  <>
                                    <div className="input-group">
                                      <button
                                        className="btn search-btn-popup"
                                        type="button"
                                        id="button-addon1"
                                      >
                                        <i className={`fa-solid  ${formik.values.shipment_mode == "air" ? "fa-plane" : "fa-ship"}`}></i>
                                      </button>
                                     
                                      <AsyncSelect
                                        className="async-select"
                                        cacheOptions
                                        loadOptions={formik.values.shipment_mode == "air" ? fetchDestinationAirport : fetchDestinationSeaport} // Called when typing to fetch options
                                        placeholder={`Type to search ${formik.values.shipment_mode == "air" ? "airports" : "seaports"}...`}
                                        isClearable
                                        isLoading={formik.values.shipment_mode == "air" ? destinationAirPortLoading : destinationSeaPortLoading}
                                        loadingMessage={() => `Fetching ${formik.values.shipment_mode == "air" ? "airports" : "ports"}...`} // Shows loading message
                                        name="destination_port_id"
                                        onChange={option => {
                                          formik.setFieldValue('destination_port_int_id', option ? option.value : null);
                                          formik.setFieldValue('destination_port_id', option ? option.label : null);
                                          formik.setFieldValue('destination_port_country_id', option ? option.country_id : null);
                                          formik.setFieldValue('destination_port_state_id', option ? option.state_id : null);
                                          formik.setFieldValue('destination_port_city_id', option ? option.city_id : null);
                                          formik.setFieldValue('destination_port_country_name', option ? option.country_name : null);
                                          formik.setFieldValue('destination_port_state_name', option ? option.state_name : null);
                                          formik.setFieldValue('destination_port_city_name', option ? option.city_name : null);
                                        }}
                                        onBlur={formik.handleBlur}
                                        styles={{
                                          dropdownIndicator: (provided) => ({
                                            ...provided,
                                            display: 'none',
                                          }),
                                          indicatorSeparator: () => ({
                                            display: 'none',
                                          }),
                                        }}
                                      />
                                    </div>
                                    {formik?.touched.destination_port_id && formik?.errors.destination_port_id ? (
                                      <div className="error">{formik.errors.destination_port_id}</div>
                                    ) : null}
                                    {formik.values.destination_port_id &&
                                      <>
                                        <div className="row mt-3 p-2">
                                          {/* <div className="col-md-4 mt-3">City</div>
                                        <div className="col-md-8 mt-3 fw-bold">Mumbai</div>
                                        <div className="col-md-4 mt-3">Country</div>
                                        <div className="col-md-8 mt-3 fw-bold">India</div> */}
                                          {formik.values.destination_port_city_name && <>
                                            <div className="col-md-4 mt-3">City</div>
                                            <div className="col-md-8 mt-3 fw-bold">{formik.values.destination_port_city_name}</div>
                                          </>}
                                          {formik.values.destination_port_country_name && <>
                                            <div className="col-md-4 mt-3">Country</div>
                                            <div className="col-md-8 mt-3 fw-bold">{formik.values.destination_port_country_name}</div>
                                          </>}
                                        </div>
                                      </>
                                    }
                                  </> :
                                  <div className="row">
                                    <div className="col-md-12">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        Address <span className="text-danger"></span>
                                      </label>
                                      <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        placeholder="Enter address"
                                        name="destination_address"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.destination_address}
                                      />
                                    </div>
                                    {formik?.touched.destination_address && formik?.errors.destination_address ? (
                                      <div className="error">
                                        {formik?.errors.destination_address}
                                      </div>
                                    ) : null}

                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        Country <span className="text-danger"></span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        styles={customStyles}
                                        options={destinationCountryOptions}
                                        name="destination_country_id"
                                        value={destinationCountryOptions.find(option => option.value === formik.values.destination_country_id)}
                                        onChange={option => {
                                          formik.setFieldValue('destination_country_id', option.value);
                                          formik.setFieldValue('destination_door_country_name', option.label);
                                          handleDestinationGetState(option.value);
                                          formik.setFieldValue('state_id', '');
                                        }}
                                        onBlur={formik.handleBlur}

                                      />
                                      {formik?.touched.destination_country_id && formik?.errors.destination_country_id ? (
                                        <div className="error">
                                          {formik?.errors.destination_country_id}
                                        </div>
                                      ) : null}
                                    </div>
                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        State <span className="text-danger"></span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        styles={customStyles}
                                        options={destinationStateOptions}
                                        name="destination_state_id"
                                        value={destinationStateOptions.find(option => option.value === formik.values.destination_state_id)}
                                        onChange={option => {
                                          formik.setFieldValue('destination_state_id', option.value);
                                          formik.setFieldValue('destination_door_state_name', option.label);
                                          handleDestinationGetCity(option.value);
                                          formik.setFieldValue('city_id', '');
                                        }}
                                        onBlur={formik.handleBlur}
                                      />
                                      {formik?.touched.destination_state_id && formik?.errors.destination_state_id ? (
                                        <div className="error">
                                          {formik?.errors.destination_state_id}
                                        </div>
                                      ) : null}
                                    </div>
                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        City <span className="text-danger"></span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        styles={customStyles}
                                        options={destinationCityOptions}
                                        name="destination_city_id"
                                        value={destinationCityOptions.find(option => option.value === formik.values.destination_city_id)}
                                        onChange={option => {
                                          formik.setFieldValue('destination_city_id', option.value);
                                          formik.setFieldValue('destination_door_city_name', option.label);
                                          formik.setFieldValue('city_id', '');
                                        }}
                                        onBlur={formik.handleBlur}
                                      />
                                      {formik?.touched.destination_city_id && formik?.errors.destination_city_id ? (
                                        <div className="error">
                                          {formik?.errors.destination_city_id}
                                        </div>
                                      ) : null}
                                    </div>

                                    <div className="col-md-6">
                                      <label
                                        for="basicpill-firstname-input"
                                        className="form-label"
                                      >
                                        Postal/Zip Code{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                      <input
                                        className="form-control form-control-sm"
                                        type="text"
                                        name="destination_pincode"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.destination_pincode}
                                        maxLength={10}
                                        placeholder={formik.values.destination_pincode_notavailable ? "Not available" : "Enter Postal/Zip code"}
                                        disabled={formik.values.destination_pincode_notavailable}
                                      />

                                      {formik?.touched.destination_pincode && formik?.errors.destination_pincode ? (
                                        <div className="error">
                                          {formik?.errors.destination_pincode}
                                        </div>
                                      ) : null}

                                      <div>
                                        <input
                                          id="destination_pincode_notavailable"
                                          type="checkbox"
                                          className="me-1"
                                          checked={formik.values.destination_pincode_notavailable}
                                          onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            formik.setFieldValue("destination_pincode_notavailable", isChecked);
                                            if (isChecked) {
                                              formik.setFieldValue("destination_pincode", "");
                                              formik.setFieldError('destination_pincode', ''); // Clear the error
                                              formik.setFieldTouched('destination_pincode', false);
                                            }
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <label
                                          for="basicpill-firstname-input"
                                          className="form-label"
                                          htmlFor="destination_pincode_notavailable"
                                        >
                                          {" "}
                                          Not available
                                        </label>

                                        <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 250, hide: 400 }}
                                          overlay={renderTooltip}
                                        >
                                          <i className="fa-solid fa-circle-info ms-1"></i>
                                        </OverlayTrigger>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </>
                          }
                        </div>
                      </div>
                    </div>

                    {/* <div className="row">
                      
                      {
                        showIncoterms && <div className="col-md-8">
                          <div className="mt-3">
                            <div className="input_box_section d-flex align-items-center gap-2">
                              <label
                                for="basicpill-firstname-input"
                                className="form-label mb-0 mt-0"
                              >
                                INCO Term
                              </label>
                              <Select
                                className="basic-single w-50"
                                classNamePrefix="select"
                                styles={customStyles}
                                options={incotermsOptions}
                                name="incoterm_id"
                                value={incotermsOptions.find(option => option.value === formik.values.incoterm_id)}
                                onChange={option => formik.setFieldValue('incoterm_id', option.value)}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.incoterm_id && formik.errors.incoterm_id ? (
                                <div className="error">{formik.errors.incoterm_id}</div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      }
                    </div> */}
                    <div className="main_detail_form mt-4">
                      <div className="main-nav-det">
                        <h4 className="form-heading-bg">General information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Full Name <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              className="form-control form-control-sm"
                              placeholder="Enter Full Name"
                              value={formik?.values?.full_name}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              pattern="[a-zA-Z\s]*"
                              onKeyPress={(event) => {
                                const inputValue = event.target.value;
                                if (
                                  inputValue.length === 0 &&
                                  event.key === " "
                                ) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            {formik?.touched.full_name &&
                              formik?.errors.full_name ? (
                              <div className="error">
                                {formik?.errors.full_name}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Phone Number <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter Phone Number"
                              name="phone"
                              value={formik?.values?.phone}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              pattern="\d*"
                              onKeyPress={(event) => {
                                if (!/\d/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              maxLength={10}
                            />
                            {formik?.touched?.phone && formik?.errors?.phone ? (
                              <div className="error">{formik?.errors?.phone}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Email Id <span>*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="Enter Email"
                              name="email"
                              value={formik?.values.email}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                            />
                            {formik?.touched.email && formik?.errors?.email ? (
                              <div className="error">{formik?.errors?.email}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4 className="form-heading-bg">Pickup Information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Pick Up Date <span>*</span>
                            </label>
                            <div
                              className="custom-datepicker"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                name="pickup_date"
                                min={new Date().toISOString().split("T")[0]}
                                value={formik.values.pickup_date || ""}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "pickup_date",
                                    e.target.value
                                  );
                                }}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.pickup_date &&
                                formik.errors.pickup_date ? (
                                <div className="error">
                                  {formik.errors.pickup_date}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Delivery Date <span>*</span>
                            </label>
                            <div
                              className="custom-datepicker"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                name="delivery_date"
                                min={new Date().toISOString().split("T")[0]}
                                value={formik.values.delivery_date || ""}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "delivery_date",
                                    e.target.value
                                  );
                                }}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.delivery_date &&
                                formik.errors.delivery_date ? (
                                <div className="error">
                                  {formik.errors.delivery_date}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Delivery Priority <span>*</span>
                            </label>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              styles={customStyles}
                              options={delPriorityOptions}
                              name="delivery_priority"
                              value={delPriorityOptions.find(option => option.value === formik.values.delivery_priority)}
                              onChange={option => formik.setFieldValue('delivery_priority', option.value)}
                              onBlur={formik.handleBlur}
                            />

                            {formik.touched.delivery_priority && formik.errors.delivery_priority ? (
                              <div className="error">{formik.errors.delivery_priority}</div>
                            ) : null}
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Requested Currency <span>*</span>
                            </label>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              styles={customStyles}
                              options={currencyOptions}
                              name="requested_currency_id"
                              value={currencyOptions.find(option => option.value === formik.values.requested_currency_id)}
                              onChange={option => formik.setFieldValue('requested_currency_id', option.value)}
                              onBlur={formik.handleBlur}
                            />

                            {formik.touched.requested_currency_id && formik.errors.requested_currency_id ? (
                              <div className="error">{formik.errors.requested_currency_id}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Commodity Type <span>*</span>
                            </label>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              styles={customStyles}
                              options={commodityOptions}
                              name="commodity_id"
                              value={commodityOptions.find(option => option.value === formik.values.commodity_id)}
                              onChange={option => formik.setFieldValue('commodity_id', option.value)}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.commodity_id && formik.errors.commodity_id ? (
                              <div className="error">{formik.errors.commodity_id}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Type of Service
                            </label>
                            <select
                              className="form-control form-control-sm"
                              name="service_type"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.service_type}
                            >
                              <option value="">-</option>
                              <option value="Freight Forwarding">Freight Forwarding</option>
                              <option value="Custom Clearance">Custom Clearance</option>
                              <option value="Both">Both</option>
                            </select>
                            {formik.touched.commodity_id && formik.errors.commodity_id ? (
                              <div className="error">{formik.errors.commodity_id}</div>
                            ) : null}
                          </div>
                        </div> */}
                      </div>
                      <div className="main-nav-det">
                        <h4 className="form-heading-bg">Cargo/Courier</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Cargo Type <span>*</span>
                            </label>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              styles={customStyles}
                              options={cargoTypeOptions}
                              name="cargo_type"
                              value={cargoTypeOptions.find(option => option.value === formik.values.cargo_type)}
                              onChange={option => formik.setFieldValue('cargo_type', option.value)}
                              onBlur={formik.handleBlur}
                            />

                            {formik.touched.cargo_type && formik.errors.cargo_type ? (
                              <div className="error">{formik.errors.cargo_type}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Cargo Description <span>*</span>
                            </label>
                            <input
                              type="cargo_description"
                              className="form-control form-control-sm"
                              placeholder="Enter Cargo Description"
                              name="cargo_description"
                              value={formik?.values.cargo_description}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                            />
                            {formik?.touched.cargo_description && formik?.errors?.cargo_description ? (
                              <div className="error">{formik?.errors?.cargo_description}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {showRowAppendForm ? formik.values.package_info_arr.map((packageItem, index) => (
                        <>
                          <div
                            key={index}
                            className={`row ${index > 0 ? "border-top" : ""}`}
                          >
                            <div className="input_box_section form-group row">
                              <div className="col-md-1">
                                <label htmlFor="quantity"
                                  for="basicpill-firstname-input"
                                  className="form-label">
                                  Qty <span>*</span>
                                </label>
                                <div className="quantity-input">
                                  <input
                                    pattern="\d*"
                                    onKeyPress={(event) => {
                                      if (!/\d/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    min={1}
                                    type="number"
                                    placeholder="Qty"
                                    className="form-control form-control-sm"
                                    value={packageItem.total_boxes}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    name={`package_info_arr.${index}.total_boxes`}
                                    maxLength={8}
                                  />
                                </div>
                                {formik.touched.package_info_arr?.[index]
                                  ?.total_boxes &&
                                  formik.errors.package_info_arr?.[index]
                                    ?.total_boxes ? (
                                  <div className="error">
                                    {
                                      formik.errors.package_info_arr[index]
                                        .total_boxes
                                    }
                                  </div>
                                ) : null}
                              </div>
                              {
                                <div className="col-md-2">
                                  <label
                                    for="basicpill-firstname-input"
                                    className="form-label">
                                    Packaging <span>*</span>
                                  </label>
                                  <div >
                                    <Select
                                      options={packageType}
                                      classNamePrefix="select"
                                      styles={customStyles}
                                      value={packageType.find(option => option.value === formik.values.package_info_arr?.[index]?.package_type_id) || null}
                                      onChange={(selectedOption) =>
                                        formik.setFieldValue(
                                          `package_info_arr.${index}.package_type_id`,
                                          selectedOption.value
                                        )
                                      }
                                      onBlur={formik.handleBlur}
                                    />
                                  </div>
                                  {formik.touched.package_info_arr?.[index]?.package_type_id &&
                                    formik.errors.package_info_arr?.[index]?.package_type_id ? (
                                    <div className="error">
                                      {formik.errors.package_info_arr[index].package_type_id}
                                    </div>
                                  ) : null}
                                </div>}

                              <div className="col-md-4">
                                {showVolume ?
                                  <div className="   ">
                                    <label htmlFor="dimensions" className="form-label">
                                      Volume {" "}
                                      <span className="required">*</span>
                                    </label>
                                    <div className="dimensions-input-container">
                                      <div className="input-wrapper">
                                        <input
                                          type="number"
                                          id="length"
                                          placeholder="Volume"
                                          step="0.01"
                                          value={packageItem.volume}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          name={`package_info_arr.${index}.volume`}
                                          min={1}
                                          max={9999}
                                          onKeyPress={(event) => {
                                            if (!/\d/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          className="dimension-input form-control form-control-sm"
                                        />
                                      </div>

                                      <select className="unit-select form-select"
                                        value={packageItem.volumeunit}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        name={`package_info_arr.${index}.volumeunit`}>
                                        <option value="" disabled>Unit</option>
                                        <option value="Cbm">Cbm</option>
                                        <option value="Cft">Cft</option>
                                      </select>
                                    </div>
                                    <div className="volume-text" onClick={() => { formik.setFieldValue("package_volume_type", "DIMENSIONS") }} style={{ cursor: "pointer" }}>
                                      Enter Dimensions
                                    </div>
                                    {formik.touched.package_info_arr?.[index]?.volume &&
                                      formik.errors.package_info_arr?.[index]?.volume ? (
                                      <div className="error">
                                        {formik.errors.package_info_arr[index].volume}
                                      </div>
                                    ) : null}
                                  </div>
                                  : <div className="   ">
                                    <label htmlFor="dimensions" className="form-label">
                                      Dimensions (L x W x H per box){" "}
                                      <span className="required">*</span>
                                    </label>
                                    <div className="dimensions-input-container">
                                      <div className="input-wrapper">
                                        <input
                                          type="number"
                                          id="length"
                                          placeholder="L"
                                          step="0.01"
                                          value={packageItem.length}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          name={`package_info_arr.${index}.length`}
                                          min={1}
                                          max={9999}
                                          onKeyPress={(event) => {
                                            if (!/\d/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          className="dimension-input form-control form-control-sm"
                                        />
                                      </div>
                                      <div className="input-wrapper">
                                        <input
                                          type="number"
                                          id="width"
                                          placeholder="W"
                                          value={packageItem.width}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          name={`package_info_arr.${index}.width`}
                                          min={1}
                                          maxLength={9999}
                                          step="0.01"

                                          onKeyPress={(event) => {
                                            if (!/\d/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          className="dimension-input form-control form-control-sm"
                                        />
                                      </div>
                                      <div className="input-wrapper">
                                        <input
                                          type="number"
                                          id="height"
                                          placeholder="H"
                                          value={packageItem.height}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          name={`package_info_arr.${index}.height`}
                                          min={1}
                                          max={9999}
                                          step="0.01"
                                          onKeyPress={(event) => {
                                            if (!/\d/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          className="dimension-input form-control form-control-sm"
                                        />
                                      </div>
                                      <select className="unit-select form-select"
                                        value={packageItem.dimensionunit}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        name={`package_info_arr.${index}.dimensionunit`}>
                                        <option value="" disabled>Unit</option>
                                        <option value="Cm">Cm</option>
                                        <option value="Inch">Inch</option>
                                      </select>
                                    </div>
                                    <div className="volume-text" onClick={() => { formik.setFieldValue("package_volume_type", "VOLUME") }}>
                                      Enter Volume
                                    </div>
                                    {formik.touched.package_info_arr?.[index]?.length &&
                                      formik.errors.package_info_arr?.[index]?.length ? (
                                      <div className="error">
                                        {formik.errors.package_info_arr[index].length}
                                      </div>
                                    ) : null}
                                    {formik.touched.package_info_arr?.[index]?.width &&
                                      formik.errors.package_info_arr?.[index]?.width &&
                                      !formik.errors.package_info_arr?.[index]?.length ? (
                                      <div className="error">
                                        {formik.errors.package_info_arr[index].width}
                                      </div>
                                    ) : null}
                                    {formik.touched.package_info_arr?.[index]?.height &&
                                      formik.errors.package_info_arr?.[index]?.height &&
                                      !formik.errors.package_info_arr?.[index]?.length &&
                                      !formik.errors.package_info_arr?.[index]?.width ? (
                                      <div className="error">
                                        {formik.errors.package_info_arr[index].height}
                                      </div>
                                    ) : null}
                                  </div>}
                              </div>

                              <div className="col-md-2">
                                <div className="   ">
                                  <label htmlFor="weight" className="form-label">
                                    Approx Weight{" "}
                                    <span className="required">*</span>
                                  </label>
                                  <div className="dimensions-input-container">
                                    <div className="input-wrapper">
                                      <input
                                        type="number"
                                        min={1}
                                        placeholder="W"
                                        value={packageItem.max_weight}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        name={`package_info_arr.${index}.max_weight`}
                                        pattern="\d*"
                                        maxLength={8}
                                        onKeyPress={(event) => {
                                          if (!/\d/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                        className="dimension-input form-control form-control-sm"
                                      />
                                    </div>

                                    <select
                                      id={`unit-select-${index}`}
                                      className="unit-select form-select"
                                      value={
                                        formik.values.package_info_arr?.[index]
                                          ?.max_weight_unit || ""
                                      }
                                      onChange={(event) =>
                                        formik.setFieldValue(
                                          `package_info_arr.${index}.max_weight_unit`,
                                          event.target.value
                                        )
                                      }
                                      onBlur={formik.handleBlur}
                                      name={`package_info_arr.${index}.max_weight_unit`}
                                    >
                                      <option value="" disabled>Unit</option>
                                      <option value="Ton">Ton</option>
                                      <option value="Kgs">Kgs</option>
                                      <option value="Lbs">Lbs</option>
                                      {/* <option value="" disabled>w</option>
                                      {weightUnit.map((unit) => (
                                        <option
                                          key={unit.value}
                                          value={unit.value}
                                        >

                                          {unit.label}
                                        </option>
                                      ))} */}
                                    </select>
                                  </div>
                                  {(formik.touched.package_info_arr?.[index]
                                    ?.max_weight_unit &&
                                    formik.errors.package_info_arr?.[index]
                                      ?.max_weight_unit) ||
                                    (formik.touched.package_info_arr?.[index]
                                      ?.max_weight &&
                                      formik.errors.package_info_arr?.[index]
                                        ?.max_weight) ? (
                                    <div className="error">
                                      {formik.errors.package_info_arr?.[index]
                                        ?.max_weight_unit ||
                                        formik.errors.package_info_arr?.[index]
                                          ?.max_weight}
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              <div className="col-md-2">
                                <div className="   ">
                                  <label htmlFor="weight" className="form-label">
                                    Total Gross Weight{" "}
                                    <span className="required">*</span>
                                  </label>
                                  <div className="dimensions-input-container">
                                    <div className="input-wrapper">
                                      <input
                                        pattern="\d*"
                                        onKeyPress={(event) => {
                                          if (!/\d/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                        type="number"
                                        min={1}
                                        placeholder="W"
                                        value={packageItem.gross_weight}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        name={`package_info_arr.${index}.gross_weight`}
                                        maxLength={8}
                                        className="dimension-input form-control form-control-sm"
                                      />
                                    </div>
                                    <select
                                      id={`unit-select-${index}`}
                                      className="unit-select form-select"
                                      value={
                                        formik.values.package_info_arr?.[index]
                                          ?.gross_weight_unit || ""
                                      }
                                      onChange={(event) =>
                                        formik.setFieldValue(
                                          `package_info_arr.${index}.gross_weight_unit`,
                                          event.target.value
                                        )
                                      }
                                      onBlur={formik.handleBlur}
                                      name={`package_info_arr.${index}.gross_weight_unit`}
                                    >
                                      <option value="" disabled>Unit</option>
                                      <option value="Ton">Ton</option>
                                      <option value="Kg">Kg</option>
                                      <option value="lbs">lbs</option>
                                      {/* {weightUnit.map((unit) => (
                                        <option
                                          key={unit.value}
                                          value={unit.value}
                                        >
                                          {unit.label}
                                        </option>
                                      ))} */}
                                    </select>
                                  </div>

                                  {(formik.touched.package_info_arr?.[index]
                                    ?.gross_weight_unit &&
                                    formik.errors.package_info_arr?.[index]
                                      ?.gross_weight_unit) ||
                                    (formik.touched.package_info_arr?.[index]
                                      ?.gross_weight &&
                                      formik.errors.package_info_arr?.[index]
                                        ?.gross_weight) ? (
                                    <div className="error">
                                      {formik.errors.package_info_arr?.[index]
                                        ?.gross_weight_unit ||
                                        formik.errors.package_info_arr?.[index]
                                          ?.gross_weight}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col-md-1">
                                {/* <span className="dimensions-icon">
                                  <i className="ti ti-plus mx-2 add-dimensions-icon"
                                    onClick={handleAddRow}></i>

                                  {formik.values.package_info_arr.length > 1 && (
                                    <i className="fa-regular fa-trash-can"
                                      onClick={() => handleRemoveRow(index)}></i>
                                  )}
                                </span> */}

                                <span className="dimensions-icon">
                                  {index === 0 ? (
                                    formik.values.package_info_arr.length === 1 ? (
                                      <span title="Add">
                                        <i
                                          className="ti ti-plus mx-2 add-dimensions-icon"
                                          onClick={handleAddRow}
                                        ></i>
                                      </span>
                                    ) : null
                                  ) : index === formik.values.package_info_arr.length - 1 ? (
                                    <>
                                      <span title="Add">
                                        <i
                                          className="ti ti-plus mx-2 add-dimensions-icon"
                                          onClick={handleAddRow}
                                        ></i>
                                      </span>
                                      <span title="Delete">
                                        <i
                                          className="fa-regular fa-trash-can mx-2"
                                          onClick={() => handleRemoveRow(index)}
                                        ></i>
                                      </span>
                                    </>
                                  ) : (
                                    <span title="Delete">
                                      <i
                                        className="fa-regular fa-trash-can"
                                        onClick={() => handleRemoveRow(index)}
                                      ></i>
                                    </span>
                                  )}
                                </span>
                              </div>

                            </div>

                          </div>


                        </>
                      )) :
                        <div>
                          <>
                            <div className="row mb-3"
                            >
                              <div className="col-md-6">
                                <div className="   ">
                                  <label for="dimensions" className="form-label">
                                    Quantity & Container{" "}
                                    <span className="required">*</span>
                                  </label>
                                  <div className="dimensions-input-container">
                                    <div className="input-wrapper">
                                      <input
                                        type="number"
                                        id="length"
                                        name="fl_quantity"
                                        placeholder="Quantity"
                                        value={formik.values.fl_quantity}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        onKeyPress={(event) => {
                                          if (!/\d/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                        min={1}
                                        className="dimension-input form-control form-control-sm"
                                      />
                                    </div>
                                    <select
                                      className="unit-select dimension-input-5"
                                      name="fl_containersize_id"
                                      value={formik.values.fl_containersize_id}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                    >
                                      <option value="">
                                        Container Size
                                      </option>
                                      {containerSizeOptions.map((val, index) => {
                                        return <option value={val.value} key={val.id}>{val.label}</option>
                                      })}
                                    </select>

                                    <select className="unit-select dimension-input-4"
                                      name="fl_containertype_id"
                                      value={formik.values.fl_containertype_id}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                    >
                                      <option value="">
                                        Container Type
                                      </option>
                                      {containerTypeOptions.map((val, index) => {
                                        return <option value={val.value} key={val.id}>{val.label}</option>
                                      })}
                                    </select>
                                  </div>

                                </div>
                                {formik?.touched.fl_quantity && formik?.errors?.fl_quantity ? (
                                  <div className="error">{formik?.errors?.fl_quantity}</div>
                                ) : null}

                                {formik?.touched.fl_containersize_id && formik?.errors?.fl_containersize_id ? (
                                  <div className="error">{formik?.errors?.fl_containersize_id}</div>
                                ) : null}

                                {formik?.touched.fl_containertype_id && formik?.errors?.fl_containertype_id ? (
                                  <div className="error">{formik?.errors?.fl_containertype_id}</div>
                                ) : null}
                              </div>

                              <div className="col-md-4">
                                <div className="   ">
                                  <label htmlFor="weight" className="form-label">
                                    Unit weight (optional){" "}
                                  </label>
                                  <div className="dimensions-input-container">
                                    <div className="input-wrapper">
                                      <input
                                        type="number"
                                        min={1}
                                        placeholder="Weight"
                                        name="fl_weight"
                                        value={formik.values.fl_weight}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        onKeyPress={(event) => {
                                          if (!/\d/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                        className="dimension-input form-control form-control-sm"
                                      />

                                    </div>

                                    <select className="unit-select dimension-input-4"
                                      name="fl_weight_unit_id"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.fl_weight_unit_id}
                                    >
                                      <option value="">Select unit</option>
                                      <option value="Ton">Ton</option>
                                      <option value="Kg">Kg</option>
                                      <option value="lbs">lbs</option>
                                    </select>


                                  </div>

                                </div>
                                {(formik.touched.fl_weight && formik.errors.fl_weight) || (formik.touched.fl_weight_unit_id && formik.errors.fl_weight_unit_id) ? (
                                  <><div className="error">Please enter weight details</div></>
                                ) : null}
                              </div>


                            </div>
                          </>


                        </div>
                      }
                       <div className="main-nav-det">
                        <h4 className="form-heading-bg">Handling Instructions</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Handling Type <span></span>
                            </label>
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              styles={customStyles}
                              options={handlingTypeOptions}
                              name="handling_type"
                              value={handlingTypeOptions.find(option => option.value === formik.values.handling_type)}
                              onChange={option => formik.setFieldValue('handling_type', option.value)}
                              onBlur={formik.handleBlur}
                            />

                            {formik.touched.handling_type && formik.errors.handling_type ? (
                              <div className="error">{formik.errors.handling_type}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Special Instruction <span></span>
                            </label>
                            <textarea
                              type="special_instruction"
                              className="form-control form-control-sm"
                              placeholder="Enter Special Instruction"
                              name="special_instruction"
                              value={formik?.values.special_instruction}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                            />
                            {formik?.touched.special_instruction && formik?.errors?.special_instruction ? (
                              <div className="error">{formik?.errors?.special_instruction}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Temperatur Condition(in celsius) <span></span>
                            </label>
                            <input
                              type="number"
                              
                              className="form-control form-control-sm"
                              placeholder="Enter Temperature in Celsius"
                              name="temperature_cond"
                              value={formik?.values.temperature_cond}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                            />

                            {formik.touched.temperature_cond && formik.errors.temperature_cond ? (
                              <div className="error">{formik.errors.temperature_cond}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Packaging Details <span></span>
                            </label>
                            <textarea
                              type="packaging_details"
                              className="form-control form-control-sm"
                              placeholder="Enter Packaging Details"
                              name="packaging_details"
                              value={formik?.values.packaging_details}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                            />
                            {formik?.touched.packaging_details && formik?.errors?.packaging_details ? (
                              <div className="error">{formik?.errors?.packaging_details}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
          <div className="form-check form-switch pt-5">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              name="insuranceRequested"
              checked={formik.values.insuranceRequested}
              onChange={(e) => {
                formik.setFieldValue("insuranceRequested", e.target.checked);
                if (!e.target.checked) {
                  formik.setFieldValue("insurance_value", ""); // Reset value if unchecked
                }
              }}
            />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
              Insurance Requested
            </label>
          </div>
        </div>

        {/* Insurance Value Field (Shown only if switch is checked) */}
        {formik.values.insuranceRequested && (
          <div className="col-md-4">
            <div className="input_box_section">
              <label htmlFor="insurance_value" className="form-label">
                Insurance Value <span>*</span>
              </label>
              <textarea
                id="insurance_value"
                className="form-control form-control-sm"
                placeholder="Enter Insurance Value"
                name="insurance_value"
                value={formik.values.insurance_value}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.insurance_value && formik.errors.insurance_value && (
                <div className="error">{formik.errors.insurance_value}</div>
              )}
            </div>
          </div>
        )}
                      </div>
                      <div className="main-nav-det">
                        <h4 className="form-heading-bg">Additionals</h4>
                      </div>
                      <div className="row">
                        {additionalsArray.map((val, _i) => {
                          return <div className="col-md-3" key={_i + 1}>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input form-switch-add"
                                type="checkbox"
                                role="switch"
                                id={`flexSwitchCheckDefault${_i}`} // Unique id for each checkbox
                                value={val?.value}
                                checked={formik.values.additionals.includes(val.value)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    // If the checkbox is checked, add the value to formik.values.additionals
                                    formik.setFieldValue('additionals', [...formik.values.additionals, val.value]);
                                  } else {
                                    // If unchecked, remove the value from formik.values.additionals
                                    formik.setFieldValue(
                                      'additionals',
                                      formik.values.additionals.filter((item) => item !== val.value)
                                    );
                                  }
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`flexSwitchCheckDefault${_i}`} // Match id with the label
                              >
                                {val.label}
                              </label>
                            </div>
                          </div>
                        })}
                      </div>
                      
                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          className="btn btn-main-form me-md-2"
                          type="submit"
                          disabled={disableSubmitBtn}
                        >
                          {disableSubmitBtn ? <><i className="fas fa-spinner fa-spin"></i> Saving</> : "Create Quotation"}
                        </button>
                      </div>
                    </div>


                  </>
                )}

              </div>
            </div>
          </div>
        </form >
      </div >
    </>
  );
};

export default QuoteFormTransportation;
